import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 500px;
  max-width: 750px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalContent = styled.div`
  padding: 32px;
  text-align: center;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  line-height: 22px;
  font-family: "Open Sans", sans-serif;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
  line-height: 22px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
`;

export const ModalQuestionConfirm = styled.p`
  font-size: 15px;
  line-height: 22px;
  color: #333;
  margin-bottom: 32px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
`;

export const ModalSpanDescription = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 22px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

export const ModalCancelButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 5px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  line-height: 1.5;

  ${(props) =>
    props.background
      ? `
        background: ${props.background};
        border: 1px solid ${props.background};
      `
      : `
        background: #e2e8f0;
        border: 1px solid #e2e8f0;
      `}

  ${(props) => (props.color ? `color: ${props.color};` : `color: #002244;`)}

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ModalConfirmButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 5px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;

  ${(props) =>
    props.background
      ? `
        background: ${props.background};
        border: 1px solid ${props.background};
      `
      : `
        background: #991b1b;
        border: 1px solid #991b1b;
      `}

  ${(props) => (props.color ? `color: ${props.color};` : `color: #fff;`)}

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
